export const DEFAULT_APP_CURRENCY = 'PKR';
export const APP_CURRENCY_STORAGE_KEY = 'appCurrency';
export const APP_CURRENCY_CHANGE_EVENT = 'app-currency-change';

export const CURRENCY_OPTIONS = [
  { code: 'PKR', name: 'Pakistani Rupee', symbol: '₨' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'SAR', name: 'Saudi Riyal', symbol: '﷼' },
  { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ' },
  { code: 'QAR', name: 'Qatari Riyal', symbol: 'ر.ق' },
  { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'د.ك' },
  { code: 'OMR', name: 'Omani Rial', symbol: 'ر.ع.' },
  { code: 'BHD', name: 'Bahraini Dinar', symbol: '.د.ب' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
  { code: 'BDT', name: 'Bangladeshi Taka', symbol: '৳' },
  { code: 'AFN', name: 'Afghan Afghani', symbol: '؋' },
  { code: 'IRR', name: 'Iranian Rial', symbol: '﷼' },
  { code: 'TRY', name: 'Turkish Lira', symbol: '₺' },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF' },
  { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
  { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM' },
  { code: 'IDR', name: 'Indonesian Rupiah', symbol: 'Rp' },
  { code: 'THB', name: 'Thai Baht', symbol: '฿' },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R' },
  { code: 'EGP', name: 'Egyptian Pound', symbol: 'E£' },
  { code: 'NGN', name: 'Nigerian Naira', symbol: '₦' },
  { code: 'BRL', name: 'Brazilian Real', symbol: 'R$' },
  { code: 'MXN', name: 'Mexican Peso', symbol: 'MX$' },
];

export function getAppCurrency() {
  try {
    const saved = localStorage.getItem(APP_CURRENCY_STORAGE_KEY);
    if (saved && CURRENCY_OPTIONS.some((item) => item.code === saved)) {
      return saved;
    }
  } catch {
    // ignore
  }
  return DEFAULT_APP_CURRENCY;
}

export function setAppCurrency(code) {
  const next = CURRENCY_OPTIONS.some((item) => item.code === code) ? code : DEFAULT_APP_CURRENCY;
  try {
    localStorage.setItem(APP_CURRENCY_STORAGE_KEY, next);
  } catch {
    // ignore
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(APP_CURRENCY_CHANGE_EVENT, { detail: next }));
  }
  return next;
}

export function formatMoney(value = 0, currencyCode) {
  const amount = Number(value || 0);
  const safeCurrency = currencyCode || getAppCurrency();

  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: safeCurrency,
    }).format(amount);
  } catch {
    return `${safeCurrency} ${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}

export function formatCompactMoney(value = 0, currencyCode) {
  const amount = Number(value || 0);
  const safeCurrency = currencyCode || getAppCurrency();
  if (amount >= 1_000_000) {
    return `${safeCurrency} ${(amount / 1_000_000).toFixed(2)}M`;
  }
  if (amount >= 1_000) {
    return `${safeCurrency} ${Math.round(amount / 1_000)}K`;
  }
  return formatMoney(amount, safeCurrency);
}
